import { FeedbackContextModel } from './feedback-context.model';

export class InitFeedbackEntry {
  static readonly type = '[Feedback] Init Feedback Entry';

  constructor(
    public payload: {
      projectId: string;
      puzzleName: string;
      featureId: string;
    }
  ) {}
}

export class SetFeedbackScore {
  static readonly type = '[Feedback] Set Feedback Score';

  constructor(
    public payload: {
      projectId: string;
      puzzleName: string;
      featureId: string;
      score: string;
    }
  ) {}
}

export class SetFeedbackContext {
  static readonly type = '[Feedback] Set Feedback Context';

  constructor(
    public payload: {
      projectId: string;
      puzzleName: string;
      featureId: string;
      context: FeedbackContextModel;
    }
  ) {}
}

export class SetFeedbackText {
  static readonly type = '[Leaderboard] Set Feedback Text';

  constructor(
    public payload: {
      projectId: string;
      puzzleName: string;
      featureId: string;
      text: string;
      email: string;
    }
  ) {}
}
